import PageTemplate from './PageTemplate';
import './ModulePage.css';

function LiveClasses() {
  return (
    <PageTemplate title="Live Classes" subtitle="Schedule and monitor live sessions">
      <div className="module-placeholder">
        <div className="module-actions">
          <input type="search" placeholder="Search live classes..." className="search-input" />
          <button className="btn-primary">Schedule Live Class</button>
        </div>
        <div className="placeholder-table">
          <p>Live class management interface will be implemented here.</p>
          <ul>
            <li>Schedule live sessions</li>
            <li>Monitor attendance</li>
            <li>Recording management</li>
            <li>Integration with video platforms</li>
          </ul>
        </div>
      </div>
    </PageTemplate>
  );
}

export default LiveClasses;
